import React from "react";

import { Avatar } from "@mui/material";

export const ManagerAvatar = ({
  managerPhotoUrl,
  managerInitials,
}: {
  managerPhotoUrl?: string;
  managerInitials: string;
}) => (
  <Avatar sx={({ palette }) => ({ bgcolor: palette.primary.main })}>
    {managerPhotoUrl ? (
      <img
        src={managerPhotoUrl}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    ) : (
      managerInitials
    )}
  </Avatar>
);
